<template>
  <div class="container mt-5">
    <div class="row align-items-center">
      <div class="col-md-12 text-center">
        <img
          src="@/assets/posko.svg"
          alt="Logo"
          class="img-fluid"
          style="width: 60%"
        />
      </div>
    </div>
    <br />
    <h1 class="text-center">Posko Gakkum ETLE</h1>
    <div
      id="collapseContainer"
      class="row border rounded p-4 custom-collapse"
      style="border: 1px solid #ced4da; background-color: #ffffff"
    >
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-8">
            <h4>Posko Gakkum ETLE</h4>
            <p>
              Alamat Posko Gakkum ETLE untuk pengaduan dan konfirmasi manual.
            </p>
          </div>
          <div class="col-md-4">
            <div class="input-group">
              <span class="input-group-text">Cari Polda</span>
              <input
                type="text"
                class="form-control"
                v-model="search"
                @input="filterPolda"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        class="col-md-6 collapse-col"
        v-for="(polda, index) in filteredPolda"
        :key="polda.id"
      >
        <div class="card">
          <div
            class="card-header"
            @click="toggleCollapse(index)"
            :aria-expanded="activeCollapse === index"
            :aria-controls="'collapse' + index"
          >
            {{ polda.nama }}
            <i class="fas fa-chevron-down collapse-icon"></i>
          </div>
          <div
            class="collapse"
            :class="{ show: activeCollapse === index }"
            :id="'collapse' + index"
          >
            <div class="card-body">
              <div
                v-for="(posko, poskoIndex) in JSON.parse(polda.info)"
                :key="poskoIndex"
              >
                <h5>{{ posko.name }}</h5>
                <p><strong>Alamat:</strong> {{ posko.address }}</p>
                <p><strong>Telepon:</strong> {{ posko.phone }}</p>
                <p><strong>Jam Operasional:</strong></p>
                <ul>
                  <li
                    v-for="(time, timeIndex) in posko.operational"
                    :key="timeIndex"
                  >
                    {{ time }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      activeCollapse: null,
      poldaData: [],
      filteredPolda: [],
      search: "",
    };
  },
  mounted() {
    this.fetchPoldaData();
  },
  methods: {
    async fetchPoldaData() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/etle/api/posko_etle.php`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.status) {
          this.poldaData = response.data.data;
          this.filteredPolda = this.poldaData;
        }
      } catch (error) {
        console.error("Error fetching Polda data:", error);
      }
    },
    toggleCollapse(index) {
      this.activeCollapse = this.activeCollapse === index ? null : index;
    },
    filterPolda() {
      this.filteredPolda = this.poldaData.filter((polda) =>
        polda.nama.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
};
</script>

<style scoped>
.collapse-col {
  margin-bottom: 20px;
}
.collapse-icon {
  float: right;
}
</style>
